module.exports = __webpack_public_path__ + "static/media/toast-icon_INFO_24px.44b6824e.svg";